import Constants from './constants';

const trackingFromServer = window.___INITIAL_STATE__.tracking || {};

const initialState = {
  googleAnalyticsId: trackingFromServer.google_analytics_id || '',
  isEnabled: trackingFromServer.is_enabled,
  isProfilePopupTimeEventEnabled: trackingFromServer.is_profile_popup_time_event_enabled,
  sendDimensions: trackingFromServer.send_dimensions,
  userCountry: trackingFromServer.user_country || '',
  userIp: trackingFromServer.user_ip || '',
  userAgent: trackingFromServer.user_useragent || '',
  screenHeight: trackingFromServer.screen_resolution_height || 0,
  screenWidth: trackingFromServer.screen_resolution_width || 0,
  deviceType: trackingFromServer.device_type || '',
  idUtPipl: trackingFromServer.id_ut_pipl || '',
};

const HANDLER = {};

/**
 * @param  {initialState} state
 * @param  {{type: string, payload: Object}} action
 */
export function trackingReducer(state = initialState, action) {
  if (HANDLER[action.type]) {
    return HANDLER[action.type](state, action);
  }

  return state;
}

export default {
  reducer: trackingReducer,
  name: Constants.MODULE_NAME,
};
